<template>
  <form action="#" @submit.prevent="submit">
    <div class="form-group max-w-md" :class="{'has-error': hasError}" qaid="serial-lookup">
      <label for="serialNumber" class="form-label">
        <span v-html="bp('contactUs.serial.number')" />
      </label>
      <div class="form-group--inline">
        <input
          id="serialNumber"
          ref="serialNumber"
          v-model="serialNumber"
          v-validate="'required'"
          type="text"
          name="serialNumber"
          class="form-control"
          :maxlength="30"
          :data-vv-as="bp('contactUs.serial.number')"
        />
        <button
          class="button button--primary button--inline md:ml-1"
          :disabled="!hasSerialNumber"
          v-html="bp('serialLookup.B2B.findBySerial')"
        />
      </div>
      <span v-if="hasError" class="form-feedback is-invalid" v-html="errors.first('serialNumber')" />
    </div>
  </form>
</template>
<script>
export default {
  name: 'TechInfoSerialSearchForm',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      serialNumber: '',
    };
  },
  computed: {
    hasSerialNumber() {
      return this.serialNumber && this.serialNumber.length > 0;
    },
    hasError() {
      return this.$validator.errors.items.length > 0;
    },
  },
  watch: {
    serialNumber(value) {
      return this.$emit('input', value);
    },
  },
  created() {
    this.serialNumber = this.value;
  },
  methods: {
    submit() {
      if (this.hasSerialNumber) {
        this.$emit('search');
      }
    },
  },
};
</script>
